import {
  enterprise_ads_features,
  enterprise_features,
  support_features,
} from 'data/Pricing/EntrpriseFeatures'
import Link from 'next/link'
import React from 'react'

const EnterpriseComingSoon = () => {
  return (
    <div className=" w-full grid grid-cols-1 md:grid-cols-2 gap-16  bg-[#E8FFFA] px-6 py-10  md:p-16 rounded-2xl items-center ">
      <div className=" flex flex-col gap-4 items-start order-last md:order-none ">
        <h3 className=" h3   !text-[30px]">Customized plans for enterprise </h3>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Customised service to meet the needs of enterprises. Everything managed with additional
          services.
        </p>

        <div className=" w-full flex  flex-col md:flex-row items-center justify-start gap-3  mt-2 md:mt-4">
          <Link href={'/support'}>
            <a className=" btn_primary   !w-full  md:!w-auto !rounded-full">Contact Sales</a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default EnterpriseComingSoon
